var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcceptPaymentMethods = function SvgAcceptPaymentMethods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accept-payment-methods_svg__a)",
    stroke: "#161616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.925 7.875v-1.05a3.15 3.15 0 0 1 3.15-3.15h26.25a3.15 3.15 0 0 1 3.15 3.15v17.85a3.15 3.15 0 0 1-3.15 3.15h-1.05",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.075 32.025h1.05a3.15 3.15 0 0 0 3.15-3.15v-17.85a3.15 3.15 0 0 0-3.15-3.15H7.875a3.15 3.15 0 0 0-3.15 3.15v1.05",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.925 12.075H3.675a3.15 3.15 0 0 0-3.15 3.15v17.85a3.15 3.15 0 0 0 3.15 3.15h26.25a3.15 3.15 0 0 0 3.15-3.15v-17.85a3.15 3.15 0 0 0-3.15-3.15Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.075 17.325H.525v5.25h32.55v-5.25Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.825 28.875h-4.2c-.58 0-1.05.47-1.05 1.05v1.05c0 .58.47 1.05 1.05 1.05h4.2c.58 0 1.05-.47 1.05-1.05v-1.05c0-.58-.47-1.05-1.05-1.05Z",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.725 32.025h5.25M4.725 28.875h9.45",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accept-payment-methods_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgAcceptPaymentMethods;